module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-builder', {
    model: {
      value: (_vm.ptw),
      callback: function($$v) {
        _vm.ptw = $$v
      },
      expression: "ptw"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cea37332"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/permits/PermitToWork.vue
// module id = 1710
// module chunks = 0